import { createElement } from 'react';
import { isFunction } from 'lodash';
import cloneElement from './cloneElement';
import isValidComponent from './isValidComponent';
import mergeProps from './mergeProps';

export default function cloneOrRender(elementOrComponent, ...props) {
    if (!elementOrComponent) return null;

    if (typeof elementOrComponent === 'string') return elementOrComponent;

    if (isFunction(elementOrComponent)) {
        const merged = mergeProps(...props);

        if (isValidComponent(elementOrComponent)) {
            const Component = elementOrComponent;
            return createElement(Component, merged);
        }

        return elementOrComponent(merged);
    }

    if (Array.isArray(elementOrComponent)) {
        return elementOrComponent.map((element) => cloneOrRender(element, ...props));
    }

    return cloneElement(elementOrComponent, ...props);
}
